import React from 'react';
import { connect as connectFormik } from 'formik';
import { Translate, withLocalize } from 'react-localize-redux';
import BbDatePicker from "../common/datePicker";
import BbInput from '../styling/bbInput';
import MarketingSection from '../marketingList/marketingSection';

class SubjectStatus extends React.Component {

    render() {
        return (<MarketingSection name={this.props.translate(this.props.label)} isOpen={this.props.isOpen || false} section="status" searchTip={this.props.translate(this.props.searchTip)} errors={this.props.errors}>
            <div className='field bb-field'>
                <div className='columns'>
                    <div className='column is-4 bb-input-label-column'>
                        <div className="label-wrapper">
                            <span className="marketing-label">
                                <Translate id='Search.SubjectStatus.RegistrationDate' />
                            </span>
                        </div>
                    </div>
                    <div className="is-flex w-100">
                        <div className='column is-6 bb-input-column'>
                            <BbDatePicker formik={this.props.formik}
                                field="status.registrationFrom"
                                value={this.props.formik.values.status.registrationFrom}
                                formDateFormat={"DD.MM.YYYY"}
                                placeholder={this.props.translate("Common.From")}
                                yearsBack={120}
                                enableReinitialize={true}
                                showError
                            />
                        </div>
                        <div className='column is-6 bb-input-column'>
                            <BbDatePicker formik={this.props.formik}
                                field="status.registrationTo"
                                value={this.props.formik.values.status.registrationTo}
                                formDateFormat={"DD.MM.YYYY"}
                                placeholder={this.props.translate("Common.To")}
                                yearsBack={120}
                                enableReinitialize={true}
                                showError
                            />
                        </div>
                    </div>
                </div>
            </div>
            <BbInput type='radio' label={this.props.translate('Search.SubjectStatus.VatPayer')} placeholder={{ type: 'column' }}
                options={this.getOptions()}
                idFormat={(val) => `$radio-status-isVatPayer-${val}`}
                checkedValue={this.getValue(this.props.formik.values.status.isVatPayer)}
                callback={(val) => this.props.formik.setFieldValue(`status.isVatPayer`, val)}
            />
            <BbInput type='radio' label={this.props.translate('Search.SubjectStatus.IsActive')} placeholder={{ type: 'column' }}
                options={this.getOptions()}
                idFormat={(val) => `$radio-status-isActive-${val}`}
                checkedValue={this.getValue(this.props.formik.values.status.isActive)}
                callback={(val) => this.props.formik.setFieldValue(`status.isActive`, val)}
            />
        </MarketingSection>);
    }

    getValue(value) {
        if (value === null || value === "")
            return ""
        else return value
    }

    getOptions = () => {
        return (
            [
                { value: "", label: "Common.DoesNotMatter" },
                { value: "1", label: 'Common.Yes.Lower' },
                { value: "0", label: 'Common.No.Lower' }
            ]
        )
    }
}

export default withLocalize(connectFormik(SubjectStatus));